// src/app/core/services/gemini-image.service.ts
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

 @Injectable({ providedIn: 'root' })
export class GeminiImageService {
     private apiUrl = environment.geminiImageApiUrl;

    async generateImage(prompt: string, options?: { aspectRatio?: '1:1' | '3:4' | '4:3' | '9:16' | '16:9' }): Promise<string> {
        const body = {
            prompt,
            aspectRatio: options?.aspectRatio ?? '4:3',
            sampleCount: 1
        };

        const res = await fetch(this.apiUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
        });
        if (!res.ok) throw new Error(`Backend error: ${res.status} - ${await res.text()}`);

        const data = await res.json();
        const img = data?.images?.[0];
        if (!img?.base64) throw new Error('No image data received from backend');

        const mime = img.mimeType || 'image/png';
        return `data:${mime};base64,${img.base64}`;
    }
}
